import { render, staticRenderFns } from "./TheRelation.vue?vue&type=template&id=6a51d9cd&scoped=true&"
import script from "./TheRelation.vue?vue&type=script&lang=js&"
export * from "./TheRelation.vue?vue&type=script&lang=js&"
import style0 from "./TheRelation.vue?vue&type=style&index=0&id=6a51d9cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51d9cd",
  null
  
)

export default component.exports